export const formName = 'followUp-form';

export const questionsId = {
  alternativeIncome: 'ALTERNATIVE_INCOME',
  undeclaredCentrelink: 'UNDECLARED_CENTRELINK',
  unsureLenderRepayment: 'UNSURE_LENDER_REPAYMENT',
  essentialNeedsAsLoanPurpose: 'ESSENTIAL_NEEDS_AS_LOAN_PURPOSE',
  ongoingTransfers: 'ONGOING_TRANSFERS',
  housingExpensesShare: 'HOUSING_EXPENSES_SHARE',
  otherExpenses: 'OTHER_EXPENSES',
  recentCreditEnquiry: 'RECENT_CREDIT_ENQUIRY',
};

export const fieldNamesArray = [
  'alternativeIncomeAmount',
  'alternativeIncomeFrequency',
  'governmentBenefits',
  'governmentBenefitsClarification',
  'unsureLenderAmount',
  'unsureLenderFrequency',
  'essentialNeeds',
  'essentialNeedsClarification',
  'ongoingTransfers',
  'ongoingTransfersExtraPart',
  'ongoingTransfersExtraPartClarification',
  'ongoingTransferExtraPartAmount',
  'housingExpenses',
  'housingExpensesClarification',
  'otherExpenses',
  'otherExpensesClarification',
  'creditEnquiry',
  'creditEnquiryAmount',
  'creditEnquiryFrequency',
];

export const fieldNames = {
  alternativeIncomeAmount: 'alternativeIncomeAmount',
  alternativeIncomeFrequency: 'alternativeIncomeFrequency',
  governmentBenefits: 'governmentBenefits',
  governmentBenefitsClarification: 'governmentBenefitsClarification',
  unsureLenderAmount: 'unsureLenderAmount',
  unsureLenderFrequency: 'unsureLenderFrequency',
  essentialNeeds: 'essentialNeeds',
  essentialNeedsClarification: 'essentialNeedsClarification',
  ongoingTransfers: 'ongoingTransfers',
  ongoingTransfersExtraPart: 'ongoingTransfersExtraPart',
  ongoingTransfersExtraPartClarification: 'ongoingTransfersExtraPartClarification',
  ongoingTransferExtraPartAmount: 'ongoingTransferExtraPartAmount',
  housingExpenses: 'housingExpenses',
  housingExpensesClarification: 'housingExpensesClarification',
  otherExpenses: 'otherExpenses',
  otherExpensesClarification: 'otherExpensesClarification',
  creditEnquiry: 'creditEnquiry',
  creditEnquiryAmount: 'creditEnquiryAmount',
  creditEnquiryFrequency: 'creditEnquiryFrequency',
};

export const frequencies = {
  WEEKLY: 'week',
  FORTNIGHTLY: 'fortnight',
  MONTHLY: 'month',
};
